import React, { FC } from "react";
import { useFormatter } from "kw/util/useFormatter";
import { SummaryTable } from "./SummaryTable";

type TCustomerDetailsSection = {
  customer: TCustomer;
};
export const CustomerDetailsSection: FC<TCustomerDetailsSection> = ({ customer }) => {
  const { formatDateTime, formatString, formatBoolean } = useFormatter();

  const email = () => {
    const ce = formatString(customer?.contactEmail);
    const e = formatString(customer?.email);

    if (e && e.includes("@")) {
      return e;
    }
    if (ce && ce.includes("@")) {
      return ce;
    }

    return "-";
  };

  const customerDetails = [
    {
      id: "id",
      label: "Customer ID",
      value: formatString(customer?.id),
    },
    {
      id: "active",
      label: "Active",
      value: formatBoolean(customer?.isActive),
    },
    {
      id: "name",
      label: "Name",
      value: formatString(`${customer?.fullName || ""}`),
    },
    {
      id: "email",
      label: "Email",
      value: email(), // TODO customer.email is a UUID -> find out why, and remove, or always alias to contactEmail
    },
    {
      id: "phone",
      label: "Phone",
      value: formatString(customer?.contactNumber),
    },
    {
      id: "created",
      label: "Created",
      value: formatDateTime(customer?.dateJoined),
    },
    {
      id: "referred",
      label: "Referred by",
      value: formatString(customer?.latestReferrer?.name),
    },
  ];
  return <SummaryTable data={customerDetails} type="CUSTOMER" />;
};
